import React from "react";
import primero from "../../assets/image/stella/flujo-tv.jpg";
import segundo from "../../assets/image/stella/flujo-tv-para-ninos.jpg";
import tercero from "../../assets/image/stella/app-flujo-tv-deporte.jpg";
import cuarto from "../../assets/image/stella/foto-de-series.jpg";

export default function Service() {
    return (
        <section
            className="py-5 md:py-20 text-center container intersect:animate-in slide-in-from-bottom intersect-once duration-1250">
            <div className="px-4 md:p-12"><h3
                className="uppercase text-3xl md:text-4xl leading-[1.3em] font-semibold">StellaTV oficial</h3><h2
                className="mt-4 uppercase text-3xl md:text-4xl leading-[1.3em] font-semibold">¿Qué ofrece Stella TV
                Oficial?</h2>
                <div className="mt-5 grid md:grid-cols-4 gap-5">
                    <div className="bg-[#1d1d1d] rounded-[30px] overflow-hidden group">
                        <div className="relative w-full h-[184px]"><img alt="Series de TV" loading="lazy"
                                                                        decoding="async" data-nimg="fill"
                                                                        className="object-cover w-full h-100"
                                                                        src={primero}/>
                        </div>
                        <div className="p-8 text-center text-white"><h4
                            className="text-2xl font-semibold group-hover:text-primary ">Series de TV</h4><p
                            className="mt-3 text-sm leading-relaxed">Disfruta de las series más populares del momento en
                            la mejor calidad, con temporadas completas disponibles aquí.</p></div>
                    </div>
                    <div className="bg-[#1d1d1d] rounded-[30px] overflow-hidden group">
                        <div className="relative w-full h-[184px]">
                            <img alt="Películas" loading="lazy" decoding="async"
                                 data-nimg="fill"
                                 className="object-cover w-full h-100"
                                 src={segundo}/>
                        </div>
                        <div className="p-8 text-center text-white"><h4
                            className="text-2xl font-semibold group-hover:text-primary">Películas</h4><p
                            className="mt-3 text-sm leading-relaxed">Aquí encontrarás las mejores películas de todos los
                            tiempos, junto con los estrenos más recientes, con la mejor calidad de imagen y audio.</p>
                        </div>
                    </div>
                    <div className="bg-[#1d1d1d] rounded-[30px] overflow-hidden group">
                        <div className="relative w-full h-[184px]"><img alt="Deportes" loading="lazy" decoding="async"
                                                                        data-nimg="fill"
                                                                        className="object-cover w-full h-100"

                                                                        src={tercero}/>
                        </div>
                        <div className="p-8 text-center text-white"><h4
                            className="text-2xl font-semibold group-hover:text-primary">Deportes</h4><p
                            className="mt-3 text-sm leading-relaxed">Más de 90 canales deportivos para disfrutar desde
                            España, México, Ecuador, Chile, Bolivia y otros países.</p></div>
                    </div>
                    <div className="bg-[#1d1d1d] rounded-[30px] overflow-hidden group">
                        <div className="relative w-full h-[184px]"><img alt="Zona Kids" loading="lazy" decoding="async"
                                                                        data-nimg="fill"
                                                                        className="object-cover w-full h-100"
                                                                        src={cuarto}/>
                        </div>
                        <div className="p-8 text-center text-white"><h4
                            className="text-2xl font-semibold group-hover:text-primary">Zona Kids</h4><p
                            className="mt-3 text-sm leading-relaxed">Contenido premium para disfrutar en familia, con
                            una extensa biblioteca de películas, series y dibujos animados para los más pequeños.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
